import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import DocumentoDigital from '~/Pages/DocumentoDigital';
import ClickSignDocumentoDigital from '~/Pages/ClickSignDocumentoDigital';
import { buscarPlataformaAtiva } from '~/Services/Service';

const PLATAFORMA_D4SIGN = 'd4sign';
const PLATAFORMA_CLICKSIGN = 'clicksign';

const TIPO_PLATAFORMA_MAP = {
  1: PLATAFORMA_D4SIGN,
  2: PLATAFORMA_CLICKSIGN,
};

const DocumentoDigitalSwitch = props => {
  const location = useLocation();
  const [plataforma, setPlataforma] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    async function verificarPlataforma() {
      const { codDocDigital } = qs.parse(location.search, {
        ignoreQueryPrefix: true,
      });

      const codigoDocDigital = codDocDigital || props.codigoDocumentoDigital;

      if (!codigoDocDigital) {
        setPlataforma(PLATAFORMA_CLICKSIGN);
        setCarregando(false);
        return;
      }

      try {
        const data = await buscarPlataformaAtiva(codigoDocDigital);

        if (TIPO_PLATAFORMA_MAP[data.tipo_plataforma]) {
          setPlataforma(TIPO_PLATAFORMA_MAP[data.tipo_plataforma]);
        } else {
          setPlataforma(PLATAFORMA_CLICKSIGN);
        }
      } catch {
        setPlataforma(PLATAFORMA_CLICKSIGN);
      } finally {
        setCarregando(false);
      }
    }

    verificarPlataforma();
  }, [location.search, props.codigoDocumentoDigital]);

  if (carregando) return null;

  if (plataforma === PLATAFORMA_CLICKSIGN) {
    return <ClickSignDocumentoDigital {...props} />;
  }

  return <DocumentoDigital {...props} />;
};

export default DocumentoDigitalSwitch;
